import store from "../../../store";
import declaration from './declaration.vue';
import declaration_info from './item/declaration_info.vue';

window.DECLARATION =  new Vue({
    store,
    el: '#declaration',
    name : "Declaration",
    created () {

    },
    components : {
        declaration,
        declaration_info
    }
})
